import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { Login as LoginForm } from '../components/Login';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: Login,
});

function Login() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <div style={{ gridArea: 'main / sidebar / main / main' }}>
          <Pane classes={'sp-register sp-login'} tag="main">
            <LoginForm />
          </Pane>
        </div>
      </div>
    </>
  );
}
